import { QRCodeCanvas } from "qrcode.react";
import "./qrcode.less"
import { useTranslation } from 'react-i18next';
const QrCode = (props: any) => {
      const { t } = useTranslation();
  const qrcode = (
    <QRCodeCanvas
      title={t("MAIN_QR_CODE")} 
      id="qrCode"
      value={props.url}
      size={200}
      fgColor="#000000"
      bgColor="#FFFFFF"
      level={"H"} 
    />
  );
  return (
    <div className="qrcode__container">
      <div className="qrcode">{qrcode}</div>
    </div>
  );
};

export default QrCode;